import {
  TIME_ENTRIES_SUMMARY_DAILY_REQUEST,
  TIME_ENTRIES_SUMMARY_DAILY_SUCCESS,
  TIME_ENTRIES_SUMMARY_DAILY_FAILURE,
} from "./actionType";

const initState = {
  timeEntriesSummaryDailyList: [],
  timeEntriesSummaryDailyListLoading: false,
  timeEntriesSummaryDailyListError: false,
};

export const TimeEntriesSummary = (state = initState, { type, payload }) => {
  switch (type) {
    case TIME_ENTRIES_SUMMARY_DAILY_REQUEST:
      return {
        ...state,
        timeEntriesSummaryDailyListLoading: true,
        timeEntriesSummaryDailyListError: false,
      };
    case TIME_ENTRIES_SUMMARY_DAILY_SUCCESS:
      return {
        ...state,
        timeEntriesSummaryDailyList: payload,
        timeEntriesSummaryDailyListLoading: false,
        timeEntriesSummaryDailyListError: false,
      };
    case TIME_ENTRIES_SUMMARY_DAILY_FAILURE:
      return {
        ...state,
        timeEntriesSummaryDailyListLoading: false,
        timeEntriesSummaryDailyListError: true,
      };
    default:
      return state;
  }
};

export default TimeEntriesSummary;
